<template>
    <div class="rounded-lg flex flex-col">
        <!-- Slika doktora -->

        <div class="relative">
            <img
                :src="doctor.image"
                :alt="`Doctor ${doctor.name}`"
                class="rounded-lg w-full h-auto object-cover hover:opacity-75 cursor-pointer overview-image"
                @click="showDialog = true"
            />
            <!--<button
                class="absolute biography bottom-0 left-0 right-0 bg-orange-500 text-white py-2 px-4 rounded-lg m-4"
                @click="showDialog = true"
            >
                {{ $t("aboutUs.biography") }}
            </button> -->
        </div>

        <!-- Ime i kratka biografija -->
        <h1 class="text-2xl mt-4">
            {{ doctor.name }}
        </h1>
        <p class="mt-4">
            {{ doctor.shortBio
            }}<span
                class="text-sm cursor-pointer text-orange-500 font-extrabold"
                @click="showDialog = true"
            >
                &nbsp;({{ $t("aboutUs.readMore") }})</span
            >
        </p>

        <!-- Dijalog -->
        <div
            v-if="showDialog"
            class="dialog fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50"
        >
            <div
                class="dialog-content bg-white rounded-lg p-6 max-w-lg w-full relative"
            >
                <!-- Dugme za zatvaranje -->
                <button
                    class="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                    @click="closeDialog"
                >
                    ✕
                </button>

                <!-- Slika doktora u dijalogu -->
                <img
                    :src="doctor.image"
                    :alt="`Doctor ${doctor.name}`"
                    class="rounded-lg w-full h-auto object-cover"
                />

                <!-- Ime doktora -->
                <h1 class="text-2xl mt-4">{{ doctor.name }}</h1>

                <!-- Telo dijaloga (skrolabilni deo) -->
                <div ref="dialogBodyRef" class="dialog-body mt-4">
                    <p>{{ doctor.fullBio }}</p>
                    <!-- Gradient overlay (fiksiran na dnu dialog-body) -->
                    <div
                        v-if="hasOverflow"
                        class="gradient-overlay sticky bottom-0 left-0 w-full h-20 pointer-events-none"
                    ></div>
                </div>

                <!-- Dugmad za linkove (izvan skrolabilnog dela) -->
                <div class="mt-4">
                    <NuxtLink
                        v-for="link in doctor.links"
                        :key="link.url"
                        :to="link.url"
                        class="flex items-center justify-center px-4 py-2 border border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white rounded-lg font-bold text-lg transition duration-200 mt-4"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span>{{ link.display }}</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-5 h-5 ml-2"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M13.5 10.5L18 6m0 0l-4.5-4.5M18 6v12.75A2.25 2.25 0 0115.75 21H6.75A2.25 2.25 0 014.5 18.75V9.75A2.25 2.25 0 016.75 7.5H12"
                            />
                        </svg>
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onUpdated, nextTick } from "vue";

// Props
const props = defineProps({
    doctor: {
        type: Object,
        required: true,
    },
});

// Reaktivne vrednosti
const showDialog = ref(false);
const dialogBodyRef = ref<HTMLElement | null>(null);
const hasOverflow = ref(false);

// Funkcija za zatvaranje dijaloga
const closeDialog = () => {
    showDialog.value = false;
    document.body.style.overflow = ""; // Vrati skrolovanje
};

// Funkcija za otvaranje dijaloga
const openDialog = () => {
    showDialog.value = true;
    document.body.style.overflow = "hidden"; // Onemogući skrolovanje
    nextTick(checkOverflow); // Proveri overflow nakon renderovanja
};

// Provera da li postoji overflow
const checkOverflow = () => {
    if (!dialogBodyRef.value) return;
    hasOverflow.value =
        dialogBodyRef.value.scrollHeight > dialogBodyRef.value.clientHeight;
};

// Pratimo promene u `showDialog`
watch(showDialog, (newValue) => {
    if (newValue) openDialog();
});

// Proveri overflow nakon montiranja i ažuriranja
onMounted(checkOverflow);
onUpdated(checkOverflow);
</script>

<style scoped>
/* Stilovi za dijalog */
.dialog {
    max-height: 100vh;
    overflow-y: auto;
    padding: 16px;
}

.dialog-content {
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Onemogući skrolovanje celog dijaloga */
    position: relative; /* Za fiksiranje gradient-a */
}

.dialog-body {
    flex: 1;
    overflow-y: auto;
    padding-right: 8px;
    position: relative; /* Za gradient */
}

/* Gradient overlay (fiksiran na dnu dialog-body) */
.gradient-overlay {
    background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 1)
    );
}

/* Sakrij skrolbar */
.dialog-body::-webkit-scrollbar {
    width: 0px;
}

.dialog-body {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

/* Hover efekat za sliku */
img:hover.overview-image {
    opacity: 0.75;
    cursor: pointer;
}
button.biography {
    width: calc(100% - 2rem); /* Full width minus the margin */
}
</style>
